module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-scrollbar-size/~/babel-runtime/core-js/object/create.js
// module id = 1762
// module chunks = 0